import { ServiceIndicator } from "../services/ServiceIndicator";
import { avatarColor, avatarInitials } from "../superAdminRules";
import {
    btnOutlineStyle,
    cardStyle,
    cardTitleStyle,
    errorStyle,
    mutedTextStyle,
    toggleButtonStyle,
} from "../superAdminStyles";
import { PharmacyEditForm } from "./PharmacyEditForm";

const ellipsisStyle = { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" };

function StatusDot({ on, onColor, offColor, minWidth, children }) {
    return (
        <div style={{ display: "flex", alignItems: "center", gap: "5px", minWidth }}>
            <span style={{ width: "7px", height: "7px", borderRadius: "50%", background: on ? "#22c55e" : offColor.dot, flexShrink: 0 }} />
            <span style={{ fontSize: "13px", color: on ? onColor : offColor.text, fontWeight: 500 }}>
                {children}
            </span>
        </div>
    );
}

function PharmacyAvatar({ name }) {
    return (
        <div style={{
            width: "42px", height: "42px", borderRadius: "10px", flexShrink: 0,
            background: avatarColor(name),
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: "13px", fontWeight: 700, color: "white", letterSpacing: "0.5px",
        }}>
            {avatarInitials(name)}
        </div>
    );
}

function PharmacyRow({ pharmacy: p, first, onEdit, onToggle }) {
    return (
        <div style={{
            display: "flex", alignItems: "center", gap: "16px",
            padding: "16px 0",
            borderTop: first ? "none" : "1px solid #f3f4f6",
        }}>
            <PharmacyAvatar name={p.name} />
            <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 600, fontSize: "14px", color: "#111827" }}>{p.name}</div>
                {p.email && (
                    <div style={{ fontSize: "12px", color: "#9ca3af", ...ellipsisStyle }}>
                        {p.email}
                    </div>
                )}
                {p.template && (
                    <div style={{ fontSize: "12px", color: "#6b7280", ...ellipsisStyle, marginTop: "2px" }}>
                        Template configuré
                    </div>
                )}
                <ServiceIndicator pharmacyId={p.id} compact />
            </div>
            <StatusDot on={p.mailConfigured} onColor="#15803d" offColor={{ dot: "#d1d5db", text: "#9ca3af" }} minWidth="130px">
                {p.mailConfigured ? "Mail configuré" : "Mail non configuré"}
            </StatusDot>
            <StatusDot on={p.active} onColor="#15803d" offColor={{ dot: "#ef4444", text: "#dc2626" }} minWidth="70px">
                {p.active ? "Active" : "Inactive"}
            </StatusDot>
            <button onClick={() => onEdit(p)} style={btnOutlineStyle}>Modifier</button>
            <button onClick={() => onToggle(p.id)} style={toggleButtonStyle(p.active)}>
                {p.active ? "Désactiver" : "Activer"}
            </button>
        </div>
    );
}

export function PharmacyListCard({ pharmacies, loading, error, onToggle, editor }) {
    const ready = !loading && !error;
    return (
        <div style={cardStyle}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "20px" }}>
                <h2 style={{ ...cardTitleStyle, margin: 0 }}>Liste des pharmacies</h2>
                {!loading && (
                    <span style={{ background: "#f3f4f6", color: "#6b7280", fontSize: "12px", fontWeight: 600, borderRadius: "12px", padding: "1px 8px" }}>
                        {pharmacies.length}
                    </span>
                )}
            </div>

            {loading && <p style={mutedTextStyle}>Chargement...</p>}
            {error && <p style={errorStyle}>{error}</p>}

            {ready && pharmacies.length === 0 && <p style={mutedTextStyle}>Aucune pharmacie</p>}

            {ready && pharmacies.map((p, idx) => (
                <div key={p.id}>
                    <PharmacyRow pharmacy={p} first={idx === 0} onEdit={editor.startEdit} onToggle={onToggle} />
                    {editor.editingId === p.id && <PharmacyEditForm pharmacyId={p.id} editor={editor} />}
                </div>
            ))}
        </div>
    );
}
